import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

export interface ProgressBarProps {
  position?: 'top' | 'right' | 'bottom' | 'left';
  progress?: number;
  className?: string;
}

const configurations = {
  top: {
    min: 0,
    max: 25,
    field: 'width',
    deg: '90',
  },
  right: {
    min: 25,
    max: 50,
    deg: '180',
  },
  bottom: {
    min: 50,
    max: 75,
    deg: '270',
  },
  left: {
    min: 75,
    max: 100,
    deg: '0',
  },
};

const loaderColor = '#35C7FF';

function ProgressBar(props: ProgressBarProps) {
  const style = useMemo(() => {
    if (props.progress === undefined) {
      return {};
    }

    const { min, max, deg } = configurations[props.position!];

    if (props.progress < min) return {};
    if (props.progress >= max)
      return {
        background: `linear-gradient(${deg}deg, ${loaderColor} 100%, white 0%)`,
      };

    const percentage = ((props.progress - min) / (max - min)) * 100;

    if (props.progress >= min && props.progress <= max) {
      return {
        background: `linear-gradient(${deg}deg, ${loaderColor} ${percentage}%, white 0%)`,
      };
    }

    return {};
  }, [props.progress, props.position]);

  return (
    <div
      className={clsx(
        styles.root,
        props.className,
        styles[`position_${props.position}`]
      )}
      style={style}
    ></div>
  );
}

export default ProgressBar;
